/* VitaFresh Kühltasche: Das Theme legt die Kühltasche (CHF 15) selbst in den Warenkorb, genau einmal.
   Ersetzt die App «Product Fees» (Upcharge). Regel (Pasci 2026-10-06; Variante hiess «Nur bei
   Erstbestellung – kann ab 2. Bestellung eingeloggt gelöscht werden», seit 12.10.2026 «Tausch ab der 2. Lieferung»,
   gleiche Varianten-ID; Hinweis im Warenkorb: snippets/vf-kuehltasche-hinweis.liquid):
   - Kunde ohne Tag coolingbag_paid (Gast oder Erstbesteller): genau eine Kühltasche,
     sobald ein Gericht im Warenkorb liegt. Wird sie entfernt oder zählt jemand sie hoch, steht sie wieder auf 1.
   - Liegt nur die Kühltasche im Warenkorb, wird sie entfernt.
   - Kunde mit dem Tag (hat schon bezahlt): Beim Anmelden entfernt das Theme die Kühltasche, die als Gast dazugelegt
     wurde (Merker im localStorage), einmal (Pasci 13.10.2026, planAnmeldung). Danach fasst es sie nie mehr an.
   Die Kühltasche zählt wie bisher zum Warenwert und wird mitrabattiert.
   Den Tag setzt Shopify Flow nach der Erstbestellung.
   plan(cart, bezahlt) ist rein und in Node testbar. Das Snippet (snippets/vf-kuehltasche.liquid) gibt am Script-Tag den Tag als
   data-bezahlt und die Artikelzahl beim Seitenaufbau als data-anzahl mit (bei 0 kein erster Abruf von /cart.js). */
(function (root) {
  "use strict";

  /* /cart.js über die Warenkorb-Basis (ein Abruf je Meldung für alle Skripte, assets/vf-warenkorb-basis.js), sonst direkt */
  function korbHolen() {
    if (root.VFWarenkorbBasis) return root.VFWarenkorbBasis.holen();
    return root.fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { if (!r.ok) throw new Error("cart.js " + r.status); return r.json(); });
  }

  var VARIANT_ID = 49512535884062; /* Produkt «Kühltasche», Handle kuhltasche-1, CHF 15.00 */
  var MAX_AKTIONEN = 12; /* Schutz gegen eine Dauerschleife, falls etwas anderes immer wieder verändert */
  var PAUSE_MS = 1000; /* Mindestabstand zwischen zwei Prüfungen */
  var NACHHOL_MS = PAUSE_MS + 100; /* Nachholen liegt knapp hinter der Pause */
  var ENTPRELLEN_MS = 500;

  function istTasche(i) { return i.variant_id === VARIANT_ID; }

  /* Was zu tun ist: Liste aus {typ:"add", id, quantity} und {typ:"change", key, quantity}. */
  function plan(cart, bezahlt) {
    if (bezahlt) return [];
    var items = (cart && cart.items) || [];
    var taschen = items.filter(istTasche);
    var gerichte = items.filter(function (i) { return !istTasche(i) && i.requires_shipping; }); /* Gutscheine und digitale Artikel brauchen keine Kühltasche */
    var out = [];
    if (!gerichte.length) {
      return taschen.map(function (z) { return { typ: "change", key: z.key, quantity: 0 }; });
    }
    if (!taschen.length) return [{ typ: "add", id: VARIANT_ID, quantity: 1 }];
    taschen.forEach(function (z, idx) {
      var soll = idx === 0 ? 1 : 0;
      if (z.quantity !== soll) out.push({ typ: "change", key: z.key, quantity: soll });
    });
    return out;
  }

  /* Kunde mit Tag, frisch angemeldet: eine Kühltasche, die noch vom Gast-Warenkorb darin liegt, kommt heraus. */
  function planAnmeldung(cart) {
    var items = (cart && cart.items) || [];
    return items.filter(istTasche).map(function (z) { return { typ: "change", key: z.key, quantity: 0 }; });
  }

  var api = { plan: plan, planAnmeldung: planAnmeldung, VARIANT_ID: VARIANT_ID };
  if (typeof module !== "undefined" && module.exports) { module.exports = api; return; }
  if (root.VFKT) return; /* Snippet doppelt eingebunden: nur eine Instanz (sonst zwei Läufe, die beide die Tasche legen) */
  root.VFKT = api;

  var doc = root.document;
  var letzte = 0, timer = null, nachhol = null, anzahl = 0, laeuft = false;
  var skript = doc.currentScript || doc.querySelector("script[data-bezahlt]");
  var bezahlt = !!(skript && skript.dataset.bezahlt === "true"); /* vom Snippet: Kunde mit Tag coolingbag_paid */
  var startAnzahl = skript ? parseInt(skript.dataset.anzahl, 10) : NaN; /* vom Snippet: cart.item_count beim Seitenaufbau (fehlt: wie bisher prüfen) */

  function post(url, body) {
    return root.fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) {
        if (!r.ok) { anzahl = MAX_AKTIONEN; throw new Error("cart " + r.status); } /* z. B. ausverkauft: nicht wiederholen */
        return r;
      });
  }

  /* Merker «im Gast-Warenkorb lag eine Kühltasche» (localStorage): setzt der Gast-Lauf, sobald eine Tasche im Warenkorb liegt oder das Theme sie
     hinzufügt. Nur dann räumt der Lauf nach dem Anmelden (Kunde mit Tag) die Tasche weg, und nur einmal (Merker danach gelöscht). Legt ein Kunde mit
     Tag bewusst selbst eine Tasche dazu, bleibt sie, auch in einem neuen Tab. */
  var MERKER = "vfkt-gast-tasche";
  function merker(setzen) {
    try {
      if (setzen === true) root.localStorage.setItem(MERKER, "1");
      else if (setzen === false) root.localStorage.removeItem(MERKER);
      else return root.localStorage.getItem(MERKER) === "1";
    } catch (e) { return setzen === undefined ? false : undefined; }
  }

  function pruefen() {
    var jetzt = Date.now();
    if (anzahl >= MAX_AKTIONEN) return;
    if (bezahlt && !merker()) return; /* nur nach dem Anmelden, wenn die Tasche vom Gast-Warenkorb stammt */
    if (laeuft || jetzt - letzte < PAUSE_MS) { nachholen(); return; } /* nicht verwerfen, nachholen */
    letzte = jetzt; laeuft = true;
    korbHolen()
      .then(function (cart) {
        var aktionen = bezahlt ? planAnmeldung(cart) : plan(cart, bezahlt);
        if (bezahlt) merker(false); /* erledigt, auch wenn keine Tasche mehr da war */
        else if (aktionen.some(function (x) { return x.typ === "add"; }) || ((cart && cart.items) || []).some(istTasche)) merker(true);
        if (!aktionen.length) { anzahl = 0; return; } /* Stand stimmt: Schutzzähler zurücksetzen */
        anzahl++;
        return aktionen.reduce(function (p, a) {
          return p.then(function () {
            return a.typ === "add"
              ? post("/cart/add.js", { items: [{ id: a.id, quantity: a.quantity }] })
              : post("/cart/change.js", { id: a.key, quantity: a.quantity });
          });
        }, Promise.resolve()).then(function () {
          /* Theme-Schnittstelle (assets/component-cart.js): zeichnet Mini-Warenkorb bzw. Seite und Zähler neu und meldet «cart-updated».
             Das Theme ändert Mengen über den Zeilenschlüssel, darum braucht es währenddessen keine Sperre mehr. */
          var neu = typeof root.refreshCart === "function" && doc.getElementById("AjaxCartForm") ? root.refreshCart() : null;
          return Promise.resolve(neu).then(function () {
            if (timer) { root.clearTimeout(timer); timer = null; } /* das eigene cart-updated löst sonst eine überflüssige Prüfung aus */
            nachholen(); /* danach einmal gegenprüfen (z. B. zweiter Tab mit demselben Warenkorb) */
          });
        });
      })
      .catch(function () { /* ohne cart.js bleibt der Warenkorb unverändert */ })
      .then(function () { laeuft = false; });
  }

  function nachholen() {
    if (nachhol) return;
    nachhol = root.setTimeout(function () { nachhol = null; pruefen(); }, NACHHOL_MS);
  }

  function planen() {
    if (timer) return;
    timer = root.setTimeout(function () { timer = null; pruefen(); }, ENTPRELLEN_MS);
  }

  function start() {
    if (startAnzahl !== 0) pruefen(); /* leerer Warenkorb: nichts zu holen; die erste Änderung meldet sich unten */
    /* Das Theme meldet Warenkorb-Änderungen mit dem Ereignis «cart-updated» und zählt im Kopf mit */
    root.addEventListener("cart-updated", planen, true);
    var zaehler = doc.querySelector("[data-header-cart-count]");
    if (zaehler) new root.MutationObserver(planen).observe(zaehler, { childList: true, characterData: true, subtree: true });
    root.addEventListener("focus", planen);
    root.addEventListener("pageshow", function (e) { if (e.persisted) planen(); }); /* Zurück-Taste (bfcache) */
    doc.addEventListener("visibilitychange", function () { if (!doc.hidden) planen(); });
  }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", start); else start();
})(typeof window !== "undefined" ? window : globalThis);
